'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHeroSection = dynamic(() => import('@/components/technologies/technology-hero'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHeroSection
                className=""
                desc="Upsurge your customer list and accelerate the profits of your brand by extending the speed of your website with CodeIgniter Web Development."
                alt="hero image"
                title="hero image"
                width={1056}
                height={572}
                path={'vuejs'}
            >
                CodeIgniter <div>Development Company</div>
            </TechHeroSection>
            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="Codelgniter Development" />

            <ContetVideoSection title="The Most Compact Framework for PHP Development">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        CodeIgniter Development is roughly based on the profound MVC (Model-View-Controller) development pattern.
                        The framework provides a specific control over the controller classes, giving your website independence
                        over the designing of the model and view classes. This web framework is well recognized for shortening the
                        website process time for various types of websites. With very compact usage of data, the PHP framework
                        allows full-featured web application development including a well-designed toolkit.
                    </p>
                    <p className="fw-400 text-secondary fs-md  mb-0">Want to build compact yet scalable web solution?</p>
                </>
            </ContetVideoSection>
            <HireProcess
                bg="bg-codeigniter"
                pageTitle="Hire CodeIgniter Developers To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using CodeIgniter."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For CodeIgniter Development? " />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best CodeIgniter Developers"
                desc="Select from different engagement models to hire CodeIgniter Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
